import styled from 'styled-components';
import { MaintenanceStyled } from '../MaintenanceStyled';
import { rem } from 'polished';

export const MaintenanceStyledAC = styled(MaintenanceStyled)`
    .content {
        background-color: ${({ theme }) => theme.colors.grey6};
        display: flex;
        flex-direction: column;
        width: 100%;
        align-items: center;
        justify-content: center;
        height: 30vh;
    }
    
    .background {
        height: 70vh;
        width: 100%;
        background: url('/public/AC/maintenance.jpg') center left no-repeat;
        background-size: cover;
    }
    
    .content > .title {
        font-size: ${rem(34)};
        font-weight: ${({ theme }) => theme.fontWeights.textExtraBold};
        color: ${({ theme }) => theme.colors.grey5};
        margin: unset;
        text-align: center;
    }
    
    .content > .description {
        font-size: ${({ theme }) => theme.fontSizes.h5};
        color: ${({ theme }) => theme.colors.grey5};
        line-height: 1.4;
        text-align: center;
    }
    
    .content > a {
        font-size: ${({ theme }) => theme.fontSizes.h4};
        background-color: ${({ theme }) => theme.colors.blue2};
        border: 1px solid ${({ theme }) => theme.colors.blue2};
        color: ${({ theme }) => theme.colors.white};
        border-radius: ${rem(24)};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        padding: ${rem(14)} ${rem(24)} ${rem(15)};
        height: ${rem(48)};
        text-decoration: none;
        
        &:hover {
            background-color: ${({ theme }) => theme.colors.grey5};
            border-color: ${({ theme }) => theme.colors.grey5};
        }
    }
    
    @media only screen and (max-width: 580px) {
        .background {
            height: 60vh;
        }
        .content {
            height: 40vh;
        }
        .content > .description {
            max-width: 95%;
        }
    }
`;
